import { withTranslation } from "react-i18next"
import { useState } from "react"
import { Button, Input } from "antd"

import { post } from "library/endpoints"
import moment from "moment"

/**
 * Footer
 */
const Footer = (props) => {
  const [displayCardInput, setDisplayCardInput] = useState(false)
  const [code, setCode] = useState(null)
  const [displayError, setDisplayError] = useState(false) 
  const [giftcard, setGiftcard] = useState(null)

  const handleOnVerify = async () => {
    try {
      setDisplayError(false)
      setGiftcard(null)
      const response = await post('frontend/giftcards/check-code', {
        code
      })

      if (response.data) {
        setGiftcard(response.data)
      } else {
        setDisplayError(true)
      }
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div style={{ background: '#f3f4f6', color: '#555', textAlign: 'center', paddingTop: 20, paddingBottom: 20, fontSize: 12 }}>
      Carte valable 1 an



      <div style={{ color: '#0097a7', textDecoration: 'underline', marginTop: 20, cursor: 'pointer' }}>
        <Button type="primary" onClick={() => setDisplayCardInput(true)}>
          Vérifier le solde d'une carte-cadeau
        </Button>
      </div>
      {
        displayCardInput && (
          <div style={{ marginTop: 20 }}>
            {
              displayError && (
                <div style={{ color: 'red'}}>Ce code n'est pas valide</div>
              )
            }

            {
              giftcard && (
                <div style={{ marginTop: 10, marginBottom: 20, textAlign: 'left', padding: 30, fontSize: 14 }}>
                  <div>Montant initial : {giftcard.amount}€</div>
                  <div>Montant restant : {giftcard.remain}€</div>
                  <div>Date de fin de validité: {moment(giftcard.created_at).add(giftcard.months, 'months').format('DD/MM/YYYY')}</div>

                </div>
              )
            }

            <Input.Group compact>
              <Input style={{ width: 200 }} placeholder="Entrez votre code" onChange={(e) => setCode(e.target.value)}/>
              <Button onClick={handleOnVerify}>Vérifier</Button>
            </Input.Group>
          </div>
        )
      }

    </div>
  )
}

export default withTranslation()(Footer)